module.exports = __webpack_public_path__ + "static/media/02.39c00ba0.png";